import React from "react";
import { Container, Typography, Box } from "@mui/material";
import { NavLink } from "react-router-dom";
import './footer.scss';

const Footer: React.FC = () => {
  return (
    <footer className="footer-agricola">
      <Container maxWidth="lg">
        <Box className="footer-content">
          {/* Colonna 1 - Policy */}
          <Box className="footer-column">
            <NavLink to="https://www.iubenda.com/privacy-policy/20127409" className="footer-link" target="_blank">
              Privacy Policy
            </NavLink>
            <NavLink to="https://www.iubenda.com/privacy-policy/20127409/cookie-policy" className="footer-link" target="_blank">
              Cookie Policy
            </NavLink>
          </Box>

          {/* Colonna 2 - Logo */}
          <Box className="footer-column footer-logo-column">
            <img
              src="/loghi/sito/logo.png"
              alt="Fabbri Agricoltura"
              className="footer-logo"
            />
          </Box>

          {/* Colonna 3 - Contatti */}
          <Box className="footer-column footer-contatti">
            <a href="tel:+393200441982" className="footer-contact-item">
              +39 3200441982
            </a>
            <a href="mailto:fabbri.agricoltura@outlook.it" className="footer-contact-item">
              fabbri.agricoltura@outlook.it
            </a>
            <a href="https://maps.app.goo.gl/fPrPAXVKa6AsXLmr9" target="_blank" rel="noopener noreferrer" className="footer-contact-item">
              Via Per S. Felice, 3 - 41031 Camposanto (MO)
            </a>
          </Box>
        </Box>

        {/* Copyright */}
        <Box className="footer-copyright">
          <Typography>
            &copy; {new Date().getFullYear()} Fabbri Agricoltura. Tutti i diritti riservati - P.iva 04004150365
          </Typography>
          <Box className="footer-credits">
            <span>design & product by</span>
            <a href="https://www.camillacinodesigndev.it/" target="_blank" rel="noopener noreferrer">
              <img src="/loghi/logo-ccdd.png" alt="Camilla Cino Design Dev" className="credits-logo" />
            </a>
          </Box>
        </Box>
      </Container>
    </footer>
  );
};

export default Footer;
